import { render, staticRenderFns } from "./Leaflet.vue?vue&type=template&id=2b8de8d7"
import script from "./Leaflet.vue?vue&type=script&lang=js"
export * from "./Leaflet.vue?vue&type=script&lang=js"
import style0 from "./Leaflet.vue?vue&type=style&index=0&id=2b8de8d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports